/**
 * Splash HOLD bounds (KAN-562). A screen deciding "show the welcome?" under
 * the splash may keep it up a little longer — only while a welcome is
 * genuinely possible and its answer (this person's receipts) has not arrived,
 * and never more than this:
 *  - SPLASH_HOLD_MAX_MS: past the moment every other splash signal (the
 *    dashboard's first-load hold, the sign-in cover, a route chunk) has
 *    cleared, the hold lingers at most this long. 800ms (the first cut) was
 *    shorter than a phone's receipts round-trip under load; 2.5s covers it
 *    and only ever costs a brand-new member on a slow network.
 *  - SPLASH_HOLD_ABSOLUTE_MS: from the moment the hold's splash cover was
 *    first seen, it is gone after today's first-load max dwell
 *    (useFirstLoadSplash's FIRST_LOAD_MAX_DWELL_MS, 3000) plus the same
 *    linger — whatever else is up.
 * Literal (not imported) so this module never pulls a hook into SplashContext's
 * graph; splashHold.test.js pins the sum.
 */
export const SPLASH_HOLD_MAX_MS = 2500;
export const SPLASH_HOLD_ABSOLUTE_MS = 3000 + SPLASH_HOLD_MAX_MS;
